module.exports = __webpack_public_path__ + "static/media/columns-solid.294b631a.svg";